import React from 'react';

function ChevronsWhite(props) {
  return (
    <svg viewBox="0 0 15 14" {...props}>
      <g fill="#FFF" fillRule="evenodd">
        <path d="M7.293 1.707A1 1 0 118.707.293l6 6a1 1 0 01.03 1.383l-5.5 6a1 1 0 01-1.474-1.352l4.853-5.294-5.323-5.323z" />
        <path
          d="M.293 1.707A1 1 0 111.707.293l6 6a1 1 0 01.03 1.383l-5.5 6a1 1 0 11-1.474-1.352L5.616 7.03.293 1.707z"
          opacity={0.3}
        />
      </g>
    </svg>
  );
}

export default ChevronsWhite;
